import styled from "styled-components";

export const Container = styled.div`
  ${({ pleft }) => pleft && `padding-left: ${pleft}`};
  ${({ pright }) => pright && `padding-right: ${pright}`};
  ${({ ptop }) => ptop && `padding-top: ${ptop}`};
  ${({ pbottom }) => pbottom && `padding-bottom: ${pbottom}`};
`;
